function Funding() {
  return <h2>Lexi likes projects and adventures. Check this out: 

    donate to the fund
  </h2>;
}
export default Funding;